<!--
 * @Description: 跟进记录
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-13 11:09:54
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main>
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        v-model:search="searchFrom"
        @fetch="fetch"
        ref="tableRef"
        tableId="FbufollowUpRecord"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item name="customerNumber" label="主客户代码">
              <a-input v-model:value="searchFrom.customerNumber" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="customerName" label="客户名称">
              <a-input v-model:value="searchFrom.customerName" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="组织部门">
              <CustomerAreaCascader type="search" appId="cos_fbu" v-model:ids="searchFrom.deptIdList" />
            </dc-form-item>
            <dc-form-item name="dutyBy" label="客户负责人">
              <user-select v-model:value="searchFrom.dutyBy" />
            </dc-form-item>
            <dc-form-item label="来源渠道">
              <a-input-group compact>
                <ParamCodeCascader
                  type="search"
                  v-model:ids="searchFrom.channelList"
                  appId="cos_fbu"
                  paramCode="fbu_source_channel"
                  style="width: 33%"
                  placeholder="请选择"
                  allowClear
                />
                <a-input v-model:value="searchFrom.channelExplain" placeholder="请输入" style="width: 67%" />
              </a-input-group>
            </dc-form-item>
            <dc-form-item name="followRefId" label="客户ID">
              <a-input v-model:value="searchFrom.followRefId" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="时间筛选">
              <a-input-group compact>
                <a-select v-model:value="searchFrom.timeType" style="width: 33%">
                  <a-select-option :value="0">创建时间</a-select-option>
                  <a-select-option :value="1">跟进时间</a-select-option>
                </a-select>
                <CosRangePicker
                  v-model:startTime="searchFrom.startTime"
                  v-model:endTime="searchFrom.endTime"
                  style="width: 67%"
                />
              </a-input-group>
            </dc-form-item>
            <!-- <dc-form-item name="endTime" label="跟进日期">
              <cos-range-picker v-model:startTime="searchFrom.startTime" v-model:endTime="searchFrom.endTime" />
            </dc-form-item> -->
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="handleAdd" v-permission="'fbu_follow_add_btn'"> 写跟进 </a-button>
          <ExportButton appId="cos_fbu" taskType="209" :search="searchFrom" v-permission="'fbu_follow_export_btn'"
            >导出</ExportButton
          >
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'startTime'">
            <p>{{ text }}~{{ record.endTime }}</p>
          </template>
          <template v-if="column.dataIndex === 'process'">
            <EditorTableText :value="text" />
          </template>
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <a-button type="link" @click="handleEdit(record)" v-permission="'fbu_follow_edit_btn'"> 编辑 </a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'fbu_follow_del_btn'"> 删除 </a-button>
              <a-button type="link" @click="handleCommit(record)" v-permission="'fbu_follow_comment_btn'">
                评论
              </a-button>
            </MoreButton>
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script setup lang="ts">
import { ref, computed, reactive, onMounted } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import CosRangePicker from '@/components/CosRangePicker/index'
import EditorTableText from '@/components/Editor/src/tableText.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { FbuFollowUpRecordParams, FbuFollowUpRecordItem } from '@/typings/api/followUpManage'
import { fbuFollowRecordsList, followRecordsDelete } from '@/api/gucangSales/followUpManage'
import { customerPhaseEnum, customerAllStatusEnum } from '@/views/gucangSales/commonEnum/dataConfig'
import { useRouter } from 'vue-router'
import { listByParamCodes } from '@/api/common'
const tableRef = ref()
const router = useRouter()
const searchFrom = ref<FbuFollowUpRecordParams>({
  timeType: 0
})
const paramCodeData = reactive<{
  fbu_follow_mode: []
  fbu_follow_purpose: []
}>({
  fbu_follow_mode: [], // 拜访方式
  fbu_follow_purpose: [] // 访客目的
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_fbu',
    paramCodes: ['fbu_follow_mode', 'fbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      Object.assign(paramCodeData, res.data)
    }
  })
}
const columns = computed(() => [
  {
    title: '客户名称',
    dataIndex: 'customerName',
    cosType: 'link',
    path: '/fbu/followUpRecord/view',
    query: ['id'],
    fixed: 'left',
    width: 200
  },
  { title: '客户ID', dataIndex: 'followRefId' },
  { title: '主客户代码', dataIndex: 'customerNumber' },
  { title: '完成访客计划', dataIndex: 'planTitle' },
  { title: '目的', dataIndex: 'fbuPurpose', dicData: paramCodeData.fbu_follow_purpose },
  { title: '客户阶段', dataIndex: 'stage', dicData: [{ label: '线索阶段', value: 1 }, ...customerPhaseEnum] }, // 1-线索阶段, 2-潜在客户阶段, 3-成交客户阶段
  { title: '客户状态', dataIndex: 'followStatus', dicData: customerAllStatusEnum },
  { title: '档次', dataIndex: 'amountLevel' },
  { title: '跟进人', dataIndex: 'dutyByName' },
  { title: '跟进时间', dataIndex: 'startTime', width: 350, sorter: true },
  { title: '具体详情', dataIndex: 'process', width: 450 },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', sorter: true, width: 160 },
  { title: '操作', dataIndex: 'action', fixed: 'right', width: 200 }
])
const fetch = (params: FbuFollowUpRecordParams, callBack: (res: any) => void) => {
  fbuFollowRecordsList(params).then((res) => {
    callBack(res)
  })
}

const handleAdd = () => {
  router.push({
    path: '/fbu/followUpRecord/add'
  })
}
const handleEdit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: '/fbu/followUpRecord/edit',
    query: {
      id: record.id
    }
  })
}
const handleCommit = (record: FbuFollowUpRecordItem) => {
  router.push({
    path: '/fbu/followUpRecord/commit',
    query: {
      id: record.id
    }
  })
}
const deleteRow = (record: FbuFollowUpRecordItem) => {
  Modal.delete({
    onOk() {
      followRecordsDelete(record.id).then(() => {
        message.success('删除成功')
        tableRef.value.delFetch()
      })
    }
  })
}
// const success = (type = 'edit') => {
//   if (type === 'add') {
//     tableRef.value?.search()
//   } else {
//     tableRef.value?.fetch()
//   }
// }
onMounted(() => {
  getByParamCodes()
})
</script>
<script lang="ts">
export default {
  name: 'DcCosFbuFollowUpRecord'
}
</script>
